module.exports = __webpack_public_path__ + "media/src/Shared/Assets/roverpass_logo-78b9b6c664d573d3345e4b24820270a881f59aa1f931546ad3fc770b9aa7ff94.svg";